export default __webpack_public_path__ + "static/media/mistake_ex_1@2x.30799db3.png";